import { Navigate } from 'react-router-dom';
import { useSession } from '../context/SessionContext';

export default function PrivateRoute({ children }) {
  const { authenticated, loading } = useSession();

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: 50 }}>Loading...</div>;
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}